// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__31z2o","loaderOuter":"PageOverlayLoader_loaderOuter__2M5L3"};